export default __webpack_public_path__ + "static/media/kashmirhome.fb5f8379.jpg";